

window.selectedProducts = [];

let selectedPeople = '';
let selectedMeals = '';
let TotalNumberofPeople = 0;
let TotalNumberofMeals = 0;
let totalNumberofServingsPerMonth = 0;
let haveSubscription = false;

document.querySelectorAll('.option-label--people').forEach(label => {
  label.addEventListener('click', () => {
    // Remove class from all
    document.querySelectorAll('.option-label--people').forEach(el => {
      el.classList.remove('selected--option-people');
    });

    // Add class to the clicked one
    label.classList.add('selected--option-people');
    selectedPeople = document.querySelector('.selected--option-people span').innerText.trim();
    const match = selectedPeople.trim().match(/^\d+/);
    TotalNumberofPeople = match ? parseInt(match[0], 10) : 0;
    if (selectedPeople.includes('+')) TotalNumberofPeople += 1;
    totalNumberofServingsPerMonth = (TotalNumberofMeals * TotalNumberofPeople) * 4;
    let personsData = document.getElementById('personsSHow');
    personsData.innerHTML = `${selectedPeople}`;
  });
});

document.querySelectorAll('.option-label--meals').forEach(label => {
  label.addEventListener('click', () => {
    // Remove class from all
    document.querySelectorAll('.option-label--meals').forEach(el => {
      el.classList.remove('selected--option-meal');
    });

    // Add class to the clicked one
    label.classList.add('selected--option-meal');
    selectedMeals = document.querySelector('.selected--option-meal span').innerText.trim();
    if (selectedMeals.includes('+')) {
      TotalNumberofMeals = parseInt(selectedMeals) + 1;
    } else if (selectedMeals.includes('-')) {
      const parts = selectedMeals.split('-');
      TotalNumberofMeals = parseInt(parts[1]);
    } else {
      TotalNumberofMeals = parseInt(selectedMeals);
    }
    totalNumberofServingsPerMonth = (TotalNumberofMeals * TotalNumberofPeople) * 4;
    let mealsData = document.getElementById('MealsShow');
    mealsData.innerHTML = `${selectedMeals} Meals / Week`;
  });
});


function updateCartSummary(Products) {
  // ==== svaing price calulator code  ======
  let davingPricing = Products.reduce((total, item) => {
    const saving = parseFloat(item.VarintSaving || 0);
    const qty = parseInt(item.qty || 0);
    return total + (saving * qty);
  }, 0);

  // =========== code for adding variant badges into cards ================
  let PDPSInCart = Products;

  // Step 1: Clear all badge containers
  document.querySelectorAll('[data-selected-container]').forEach(container => {
    container.innerHTML = '';
  });
  
  // Step 2: Group variants by productId
  let groupedByProduct = {};
  PDPSInCart.forEach(item => {
    if (!groupedByProduct[item.productId]) {
      groupedByProduct[item.productId] = [];
    }
    groupedByProduct[item.productId].push(item);
  });
  
  // Step 3: Use <select> option order to render spans correctly
  Object.entries(groupedByProduct).forEach(([productId, variants]) => {
    let badgeContainers = document.querySelectorAll(`[data-selected-container="container-${productId}"]`);
  
    badgeContainers.forEach(container => {
      const parent = container.closest('[data-selected-container]').parentElement;
      const select = parent.querySelector('select');
  
      if (!select) return;
  
      const orderedSpans = [];
  
      // Loop through <option>s to maintain order
      Array.from(select.options).forEach(option => {
        const variantId = option.value;
        const matchingItem = variants.find(v => v.variantId === variantId);
        if (matchingItem) {
          orderedSpans.push(`<span>${matchingItem.variantTitle} X ${matchingItem.qty}</span>`);
        }
      });
  
      container.innerHTML = orderedSpans.join('');
    });
  });
  
  
  // =========== code for adding variant badges into cards ================
  const summary = document.getElementById('quiz-cart-summary');
  let deskPrice = document.getElementById('desk__price');
  let deskSaving = document.getElementById('desk__price-saving');
  let deskitems = document.getElementById('desk__items');
  let deskBtn = document.getElementById('add-selected-to-cart-desktop');
  let total = 0;
  Products = Products.reverse();
  Products.forEach((product) => {
    total += parseFloat(product.price || 0); // No rounding or truncation here
  });
  
  let totalNumberofServings = Products.reduce((sum, product) => {
    return sum + (Number(product.variantServing) * product.qty);
  }, 0); 

  let discountten = (total * 10) / 100;
  
  let DiscountPrice = `$${davingPricing.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} USD`;

  // Format for display only (2 decimals, with commas)
  summary.innerHTML = `SERVINGS: (${totalNumberofServings}/${totalNumberofServingsPerMonth}) | TOTAL: $${total.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} USD <span class="mobile__saving" style="color: green;">SAVINGS: ${DiscountPrice}</span>`;

  if(deskBtn) {
    if(totalNumberofServings >= totalNumberofServingsPerMonth) {
      deskBtn.removeAttribute('disabled');
      deskBtn.querySelector('span').textContent = `Continue`;
      deskBtn.addEventListener('click', function(e){
        e.preventDefault();
        let cartingButton = document.getElementById('add-selected-to-cart');
        cartingButton.click();
      });

    } else {
      deskBtn.setAttribute('disabled', true);
      deskBtn.querySelector('span').textContent = `Add ${totalNumberofServingsPerMonth} minimum servings to continue`;
    }
  }

  if (totalNumberofServings >= totalNumberofServingsPerMonth) {
    let selectedCTA = document.getElementById('add-selected-to-cart');
    selectedCTA.removeAttribute('disabled');
    selectedCTA.querySelector('span').textContent = 'Continue';
  } else {
    let selectedCTA = document.getElementById('add-selected-to-cart');
    selectedCTA.setAttribute('disabled', '');
    selectedCTA.querySelector('span').textContent = `Add ${totalNumberofServingsPerMonth} minimum meals to continue`;
  }

  if(deskitems) {
    deskitems.innerHTML = `Total Servings: ${totalNumberofServings}/${totalNumberofServingsPerMonth}`;
  }

  if (deskPrice) {
    deskPrice.innerHTML = `TOTAL: $${total.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} USD`;
  }
  if (deskSaving) {
    deskSaving.innerHTML = `Total Saving $${davingPricing.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} USD`;
  }

  let totalWidthPercentage = (totalNumberofServings / totalNumberofServingsPerMonth) * 100;

  let ProgressBarWidth = document.querySelector('.summary__inner_progress');
  ProgressBarWidth.style.setProperty('--progress-width',`${totalWidthPercentage}%`);

  // ==== append selected items cart summry area ===
  let cartSummaryItemsContainer = document.getElementById('selected-items-container');
  let selectedProductsCards = '';
  
  if (Products.length > 0) {
    Products.forEach(selectedProduct => {
      selectedProductsCards += `
        <div class="summary__card">
          <div class="summary__card-img">
            <img src="${selectedProduct.image}" />
          </div>
          <div class="summary__card-content">
            <div class="summary__card-title">
              <span class="summary__card-title-text">
                ${selectedProduct.title}
              </span>
              <button data-item-remove-from-summary="${selectedProduct.productId}" onclick="removeProductFromSelection('${selectedProduct.productId}', '${selectedProduct.variantId}')"">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 5.32163C2.5 4.91829 2.7875 4.59079 3.1425 4.59079H5.36333C5.80417 4.57746 6.19333 4.25829 6.34333 3.78663L6.36833 3.70329L6.46417 3.37746C6.5225 3.17746 6.57333 3.00246 6.645 2.84663C6.92667 2.23079 7.44833 1.80329 8.05083 1.69413C8.20417 1.66663 8.36583 1.66663 8.55083 1.66663H11.4492C11.635 1.66663 11.7967 1.66663 11.9492 1.69413C12.5517 1.80329 13.0742 2.23079 13.355 2.84663C13.4267 3.00246 13.4775 3.17663 13.5367 3.37746L13.6317 3.70329L13.6567 3.78663C13.8067 4.25829 14.2733 4.57829 14.715 4.59079H16.8567C17.2125 4.59079 17.5 4.91829 17.5 5.32163C17.5 5.72496 17.2125 6.05246 16.8575 6.05246H3.14167C2.7875 6.05246 2.5 5.72496 2.5 5.32163Z" fill="#F73030"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.66338 18.3334H10.3367C12.6559 18.3334 13.8151 18.3334 14.5701 17.5951C15.3234 16.8567 15.4001 15.6459 15.5542 13.2242L15.7767 9.73422C15.8601 8.42005 15.9017 7.76255 15.5242 7.34672C15.1459 6.93005 14.5076 6.93005 13.2301 6.93005H6.77005C5.49255 6.93005 4.85338 6.93005 4.47588 7.34672C4.09838 7.76339 4.13922 8.42005 4.22338 9.73422L4.44588 13.2242C4.60005 15.6459 4.67672 16.8576 5.43088 17.5951C6.18505 18.3334 7.34422 18.3334 9.66338 18.3334ZM8.53838 10.1576C8.50505 9.79589 8.19838 9.53255 7.85505 9.56839C7.51088 9.60422 7.26088 9.92672 7.29505 10.2884L7.71172 14.6742C7.74505 15.0359 8.05172 15.2992 8.39505 15.2634C8.73922 15.2276 8.98922 14.9051 8.95505 14.5434L8.53838 10.1576ZM12.1459 9.56839C12.4892 9.60422 12.7401 9.92672 12.7051 10.2884L12.2884 14.6742C12.2551 15.0359 11.9476 15.2992 11.6051 15.2634C11.2609 15.2276 11.0109 14.9051 11.0451 14.5434L11.4617 10.1576C11.4951 9.79589 11.8034 9.53255 12.1459 9.56839Z" fill="#F73030"/>
                </svg>
              </button>
            </div>
            <div class="summary__card-variant">
              <span>${selectedProduct.variantTitle}</span>
              <span>Quantitiy: ${selectedProduct.qty}</span>
              <span>$${Number(selectedProduct.price).toFixed(2)} USD</span>
            </div>
          </div>
        </div>
      `;
    });
  }
  
  cartSummaryItemsContainer.innerHTML = selectedProductsCards;

  
}

let allergyCOntinueButton = document.getElementById('allergy-next-step-btn');
allergyCOntinueButton.addEventListener('click', function() {
  updateCartSummary(selectedProducts);
});

let selectionofSelling = document.querySelector('.add-selling___plan');
selectionofSelling.addEventListener('click', function(){
  haveSubscription = true;
});

let NOSellingPLan = document.querySelector('#no__selling_plan');
NOSellingPLan.addEventListener('click', function(){
  haveSubscription = false;
});

// click on remove buttoninto summary 
function removeProductFromSelection(ProID,VarID) {
  const pro = document.querySelector(`.toggle-selection-btn[data-product-id="${ProID}"]`);
  let quiz_quantitiy = document.querySelector(`.quiz_quantity[data-id="${ProID}"]`);
  if (pro) {
    // Assuming itemID and VariantID are already defined
    let varaintsList = document.querySelector(`select[data-product-id="${ProID}"] option[value="${VarID}"]`);

    // Check if the option exists
    if (varaintsList) {
      // Set the option as selected
      varaintsList.selected = true;

      // Get the select element
      const selectElement = varaintsList.closest('select');

      // Manually trigger the 'change' event on the select element
      const event = new Event('change');
      selectElement.dispatchEvent(event);
    }
    pro.click();
    quiz_quantitiy.value = 1;
  } else {
    console.warn(`Button with data-product-id="${ProID}" not found.`);
  }
}


document.addEventListener('DOMContentLoaded', function () {
  let selectedProducts = window.selectedProducts;

  // Add/Remove Button Click Logic
  document.querySelectorAll('.toggle-selection-btn').forEach(button => {
    button.addEventListener('click', function () {
      const productId = this.dataset.productId;
      const variantSelect = document.querySelector(`.quiz-product-variants[data-product-id="${productId}"]`);
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const variantId = selectedOption.value;
      const price = parseFloat(selectedOption.dataset.price || 0);
      let SellingPLan = this.getAttribute('data-selling-plan');
      let servingQty = selectedOption.getAttribute('data-varaint-serving');
      let savingPrice = Number(selectedOption.getAttribute('data-saving-price'));
      // Get product image and title
      const productImage = this.closest('.card-wrapper').querySelector('img').src;
      const productTitle = this.closest('.card-wrapper').querySelector('.card__heading a').textContent;
      const productQuantitiy = Number(this.closest('.card-wrapper').querySelector('.quiz__quantitiy-wrapper input').value);
      const ProductVariantName = this.getAttribute('data-first-varaint-title');

      // Find product by productId
      const index = selectedProducts.findIndex(item => item.productId === productId);

      if (index !== -1) {
        // Product already exists in selectedProducts, find if variantId exists
        const productInArray = selectedProducts.filter(item => item.productId === productId);
        console.log('PDP in ARRAY', productInArray);

        // Check if there's any product with the same variantId
        const isVariantIdAlreadyPresent = productInArray.some(item => Number(item.variantId) === Number(variantId));

        if (isVariantIdAlreadyPresent) {
          console.log('NEED TO REMOVE');
          
          // Remove all items with the same variantId from selectedProducts
          selectedProducts = selectedProducts.filter(item => Number(item.variantId) !== Number(variantId));
          
          console.log(selectedProducts);
          this.classList.remove('selected');
          this.classList.remove('hidden');
          this.previousElementSibling.classList.remove('d-flex__force');
        } else {
          console.log('Adding new product:', variantId);
          let varUpdatePrice = selectedOption.getAttribute('data-price');
          let varUpdateTitle = selectedOption.getAttribute('data-title');
          // Add the new product to selectedProducts if the variantId is unique
          selectedProducts.push({ 
            productId, 
            variantId, 
            price: varUpdatePrice, 
            image: productImage, 
            title: productTitle,
            qty: productQuantitiy,
            variantTitle: varUpdateTitle,
            sellingPlan: SellingPLan,
            variantServing: servingQty,
            VarintSaving: savingPrice
          });
          
          // Update the UI for adding the product
          this.classList.add('hidden');
          this.previousElementSibling.classList.add('d-flex__force');
        }
      } else {
        // Product is not yet in selectedProducts, add it
        selectedProducts.push({ 
          productId, 
          variantId, 
          price, 
          image: productImage, 
          title: productTitle,
          qty: productQuantitiy,
          variantTitle: ProductVariantName,
          sellingPlan: SellingPLan,
          variantServing: servingQty,
          VarintSaving: savingPrice
        });
        
        // Update the UI for adding the product
        this.classList.add('hidden');
        this.previousElementSibling.classList.add('d-flex__force');
      }

      console.log('Selected Products:', selectedProducts);
      updateCartSummary(selectedProducts);
    });
  });


// quantitiychange listner 

document.querySelectorAll('[data-quiz-qua-plus]').forEach(quanlus => {
  quanlus.addEventListener('click', function () {

    let itemID = this.getAttribute('data-quiz-qua-plus');
    let VariantID = this.getAttribute('data-variant-id');
    const productInArray = selectedProducts.find(item => item.variantId === VariantID);

    let qtyInput = this.previousElementSibling;
    let currentQty = Number(qtyInput.value);
    let updatedQty = currentQty + 1;
    qtyInput.value = updatedQty;
    let NewPrice = Number(this.getAttribute('data-price')) * updatedQty;
    if (productInArray) {
      productInArray.qty = updatedQty;
      productInArray.price = NewPrice;
      
    }


    // ========= updte cards data ===========
    // ==== getting data for serving saving and all details ======
        let SelectedOption = document.querySelector(`option[value="${VariantID}"]`);
        let isFirstOption = SelectedOption.getAttribute('data-first-option');
        let NewServings = Number(SelectedOption.getAttribute('data-varaint-serving'));
        let NewInitialPrice = Number(SelectedOption.getAttribute('data-initial-price'));
        let NewServingPrice = Number(SelectedOption.getAttribute('data-variant-serving-price'));
        let NewTotalSave = Number(SelectedOption.getAttribute('data-variant-actual-serving-price'));
        let NewTotalDiscount = Number(SelectedOption.getAttribute('data-price'));
        let newTotalSaveValue = Number(SelectedOption.getAttribute('data-variant-total-save'));

        let ServingContainer = document.querySelector(`[data-serving-${itemID}]`);
        let ServingSavingPriceContainer = document.querySelector(`[data-serving-saving-${itemID}]`);
        let SaveContainerServing = document.querySelector(`[data-total-saving-${itemID}]`);
        let priceElement = document.querySelector(`[data-price-${itemID}]`);
        let DefaultSelectedPrice = SelectedOption.dataset.price;

        if(isFirstOption != null) {
          if (ServingContainer) {
            ServingContainer.innerHTML = (NewServings*updatedQty);
          } 
          if (ServingSavingPriceContainer) {
            ServingSavingPriceContainer.innerHTML = `${isFirstOption}`;
          }
          if (SaveContainerServing) {
            SaveContainerServing.innerHTML = `$0`;
          }
        } else {
          if (ServingContainer) {
            ServingContainer.innerHTML = (NewServings*updatedQty);
          } 
          if (ServingSavingPriceContainer) {
            ServingSavingPriceContainer.innerHTML = `<u class="color_black">$${(NewInitialPrice * updatedQty).toFixed(2)}</u><u class="color_green">$${(NewServingPrice * updatedQty).toFixed(2)}</u>`;
          }
          if (SaveContainerServing) {
            SaveContainerServing.innerHTML = `<u class="color_green">$${(newTotalSaveValue * updatedQty).toFixed(2)}</u>`;
          }
        }
        
        if (priceElement) {
          if(isFirstOption != null) {
            priceElement.innerHTML = `$${(DefaultSelectedPrice * updatedQty).toFixed(2)}`;
          } else {
            priceElement.innerHTML = `<u class="color_black">$${(NewTotalSave * updatedQty).toFixed(2)}</u><u class="color_green">$${(NewTotalDiscount * updatedQty).toFixed(2)}</u>`;
          }
        }


    updateCartSummary(selectedProducts);
  });
});

document.querySelectorAll('[data-quiz-qua-minus]').forEach(quanlus => {
  quanlus.addEventListener('click', function () {

    let itemID = this.getAttribute('data-quiz-qua-minus');
    let VariantID = this.getAttribute('data-variant-id');
    const productInArray = selectedProducts.find(item => item.variantId === VariantID);

    let qtyInput = this.nextElementSibling;
    let currentQty = Number(qtyInput.value);
    let updatedQty;

    if (currentQty > 1) {
      updatedQty = currentQty - 1;
    // ========= updte cards data ===========
    // ==== getting data for serving saving and all details ======
        let SelectedOption = document.querySelector(`option[value="${VariantID}"]`);
        let isFirstOption = SelectedOption.getAttribute('data-first-option');
        let NewServings = Number(SelectedOption.getAttribute('data-varaint-serving'));
        let NewInitialPrice = Number(SelectedOption.getAttribute('data-initial-price'));
        let NewServingPrice = Number(SelectedOption.getAttribute('data-variant-serving-price'));
        let NewTotalSave = Number(SelectedOption.getAttribute('data-variant-actual-serving-price'));
        let NewTotalDiscount = Number(SelectedOption.getAttribute('data-price'));
        let newTotalSaveValue = Number(SelectedOption.getAttribute('data-variant-total-save'));

        let ServingContainer = document.querySelector(`[data-serving-${itemID}]`);
        let ServingSavingPriceContainer = document.querySelector(`[data-serving-saving-${itemID}]`);
        let SaveContainerServing = document.querySelector(`[data-total-saving-${itemID}]`);
        let priceElement = document.querySelector(`[data-price-${itemID}]`);
        let DefaultSelectedPrice = SelectedOption.dataset.price;

        if(isFirstOption != null) {
          if (ServingContainer) {
            ServingContainer.innerHTML = (NewServings*updatedQty);
          } 
          if (ServingSavingPriceContainer) {
            ServingSavingPriceContainer.innerHTML = `${isFirstOption}`;
          }
          if (SaveContainerServing) {
            SaveContainerServing.innerHTML = `$0`;
          }
        } else {
          if (ServingContainer) {
            ServingContainer.innerHTML = (NewServings*updatedQty);
          } 
          if (ServingSavingPriceContainer) {
            ServingSavingPriceContainer.innerHTML = `<u class="color_black">$${(NewInitialPrice * updatedQty).toFixed(2)}</u><u class="color_green">$${(NewServingPrice * updatedQty).toFixed(2)}</u>`;
          }
          if (SaveContainerServing) {
            SaveContainerServing.innerHTML = `<u class="color_green">$${(newTotalSaveValue * updatedQty).toFixed(2)}</u>`;
          }
        }
        
        if (priceElement) {
          if(isFirstOption != null) {
            priceElement.innerHTML = `$${(DefaultSelectedPrice * updatedQty).toFixed(2)}`;
          } else {
            priceElement.innerHTML = `<u class="color_black">$${(NewTotalSave * updatedQty).toFixed(2)}</u><u class="color_green">$${(NewTotalDiscount * updatedQty).toFixed(2)}</u>`;
          }
        }
      updateCartSummary(selectedProducts);
    } else {
      // Assuming itemID and VariantID are already defined
      let varaintsList = document.querySelector(`select[data-product-id="${itemID}"] option[value="${VariantID}"]`);

      // Check if the option exists
      if (varaintsList) {
        // Set the option as selected
        varaintsList.selected = true;

        // Get the select element
        const selectElement = varaintsList.closest('select');

        // Manually trigger the 'change' event on the select element
        const event = new Event('change');
        selectElement.dispatchEvent(event);
      }
      updatedQty = 1;
      let removeButton = document.querySelector(`.toggle-selection-btn[data-product-id="${itemID}"]`);
      removeButton.click();
      updateCartSummary(selectedProducts);
    }

    qtyInput.value = updatedQty;
    let NewPrice = Number(this.getAttribute('data-price')) * updatedQty;
    if (productInArray) {
      productInArray.qty = updatedQty;
      productInArray.price = NewPrice;
      console.log(`Updated Quantity for product ${itemID}`);
      updateCartSummary(selectedProducts);
    }
  });
  updateCartSummary(selectedProducts);
});


// summary items toggle code 
let summrytoggleButton = document.querySelector(`.summary__items-toggle`);

if (summrytoggleButton) {
  summrytoggleButton.addEventListener('click', function(e) {
    e.preventDefault();
    summrytoggleButton.classList.toggle('summary__items-toggle--active');
    let toggleContainer = document.getElementById('selected-items-container');
    if (toggleContainer) {
      toggleContainer.classList.toggle('selected-items-container__block');
    }
  });
}


let lastStepBtn = document.getElementById('add-selected-to-cart');
lastStepBtn.addEventListener('click', function(e){
  e.preventDefault();
  let stepCollections = document.querySelector('.quiz-step.step-two');
  stepCollections.classList.add('hidden');
  let SubscriptionStep = document.querySelector('.quiz-step.step-three');
  SubscriptionStep.classList.remove('hidden');
});

// Add to Cart Button
document.getElementById('next-btn-checkout').addEventListener('click', function () {
  if (selectedProducts.length === 0) {
    alert('Please select some products first!');
    return;
  }

  let items = [];

  if (haveSubscription === true) {
    items = selectedProducts.map(item => ({
      id: item.variantId,
      quantity: item.qty,
      selling_plan: Number(item.sellingPlan)
    }));
  } else {
    items = selectedProducts.map(item => ({
      id: item.variantId,
      quantity: item.qty
    }));
  }

  // Step 1: Add items to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(response => {
      if (!response.ok) throw new Error('Something went wrong while adding items');
      return response.json();
    })
    .then(data => {
      console.log('Cart updated!', data);

      // Step 2: Add cart note
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: 'Order From Bundle Builder' })
      });
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to update cart note');
      return response.json();
    })
    .then(data => {
      console.log('Cart note added:', data);
      window.location.href = '/checkout/';
    })
    .catch(error => {
      console.error('Cart error:', error);
    });
});



  // Variant Change Listener
  document.querySelectorAll('.quiz-product-variants').forEach(select => {
    select.addEventListener('change', function () {
      const productId = this.dataset.productId;
      const newVariantId = this.value;
      const productInArray = selectedProducts.filter(item => item.productId === productId);
      const minusBtnVarID = document.querySelector(`button[data-quiz-qua-minus="${productId}"]`);
      const plusBtnVarID = document.querySelector(`button[data-quiz-qua-plus="${productId}"]`);
      let updateOnloadVaraintTitile = document.querySelector(`.toggle-selection-btn[data-product-id="${productId}"]`);
      let variantInArray = null;
      let onLoadNewVaraintTitleUpdate = this.options[this.selectedIndex].getAttribute('data-title');

      let wwPrice = this.options[this.selectedIndex].dataset.price;
      minusBtnVarID.setAttribute('data-variant-id',newVariantId);
      plusBtnVarID.setAttribute('data-variant-id',newVariantId);
      minusBtnVarID.setAttribute('data-price',wwPrice);
      plusBtnVarID.setAttribute('data-price',wwPrice);

      updateOnloadVaraintTitile.setAttribute('data-first-varaint-title',onLoadNewVaraintTitleUpdate);
      
      for (let i = 0; i < productInArray.length; i++) {
        console.log(productInArray[i].variantId);
        if (Number(productInArray[i].variantId) == Number(newVariantId)) {
          variantInArray = productInArray[i];
          break; // Exit the loop once the variant is found
        }
      }
  
      if (variantInArray) {
        // Variant already exists, update it
        let alreadyQty = variantInArray.qty;
        let alreadyUpdateInput = document.querySelector(`.quiz_quantity[data-id="${productId}"]`);
        alreadyUpdateInput.value = alreadyQty;
  
        let valueOfInput = Number(document.querySelector(`.quiz_quantity[data-id="${productId}"]`).value);
        const newVariantTitle = this.options[this.selectedIndex].getAttribute('data-title');
        let newPrice = '';
        const minusBtn = document.querySelector(`button[data-quiz-qua-minus="${productId}"]`);
        const plusBtn = document.querySelector(`button[data-quiz-qua-plus="${productId}"]`);
  
        if (valueOfInput > 1) {
          newPrice = parseFloat(this.options[this.selectedIndex].dataset.price || 0) * valueOfInput;
        } else {
          newPrice = parseFloat(this.options[this.selectedIndex].dataset.price || 0);
        }
  
        // Update the existing variant
        variantInArray.variantId = newVariantId;
        variantInArray.price = newPrice;
        variantInArray.variantTitle = newVariantTitle;
  
        console.log(`Updated variant for product ${productId} to ${newVariantId}`);
        minusBtn.setAttribute('data-price', wwPrice);
        plusBtn.setAttribute('data-price', wwPrice);
        let ppparent = alreadyUpdateInput?.parentElement;

        if (ppparent) {
          ppparent.classList.add('d-flex__force');
        
          if (ppparent.nextElementSibling) {
            ppparent.nextElementSibling.classList.add('hidden');
          }
        }

        // ========= if in array then need to update values ===========
        let isFirstOption = this.options[this.selectedIndex].getAttribute('data-first-option');
        let NewServings = this.options[this.selectedIndex].getAttribute('data-varaint-serving');
        let NewInitialPrice = this.options[this.selectedIndex].getAttribute('data-initial-price');
        let NewServingPrice = this.options[this.selectedIndex].getAttribute('data-variant-serving-price');
        let NewTotalSave = this.options[this.selectedIndex].getAttribute('data-variant-actual-serving-price');
        let NewTotalDiscount = this.options[this.selectedIndex].getAttribute('data-price');
        let newTotalSaveValue = this.options[this.selectedIndex].getAttribute('data-variant-total-save');

        let ServingContainer = document.querySelector(`[data-serving-${productId}]`);
        let ServingSavingPriceContainer = document.querySelector(`[data-serving-saving-${productId}]`);
        let SaveContainerServing = document.querySelector(`[data-total-saving-${productId}]`);
        const priceElement = this.closest('.card-wrapper').querySelector('.card_product-price');


        if(isFirstOption != null) {
          if (ServingContainer) {
            ServingContainer.innerHTML = NewServings * alreadyQty;
          } 
          if (ServingSavingPriceContainer) {
            ServingSavingPriceContainer.innerHTML = `${isFirstOption}`;
          }
          if (SaveContainerServing) {
            SaveContainerServing.innerHTML = `$0`;
          }
          if (priceElement) {
            if(isFirstOption != null) {
              priceElement.innerHTML = `$${(wwPrice * alreadyQty).toFixed(2)}`;
            } else {
              priceElement.innerHTML = `<u class="color_black">$${(NewTotalSave * alreadyQty).toFixed(2)}</u><u class="color_green">$${(NewTotalDiscount * alreadyQty).toFixed(2)}</u>`;
            }
          }
        } else {
          if (ServingContainer) {
            ServingContainer.innerHTML = NewServings * alreadyQty;
          } 
          if (ServingSavingPriceContainer) {
            ServingSavingPriceContainer.innerHTML = `<u class="color_black">$${(NewInitialPrice * alreadyQty).toFixed(2)}</u><u class="color_green">$${(NewServingPrice * alreadyQty).toFixed(2)}</u>`;
          }
          if (SaveContainerServing) {
            SaveContainerServing.innerHTML = `<u class="color_green">$${(newTotalSaveValue * alreadyQty).toFixed(2)}</u>`;
          }
          if (priceElement) {
            if(isFirstOption != null) {
              priceElement.innerHTML = `$${(wwPrice * alreadyQty).toFixed(2)}`;
            } else {
              priceElement.innerHTML = `<u class="color_black">$${(NewTotalSave * alreadyQty).toFixed(2)}</u><u class="color_green">$${(NewTotalDiscount * alreadyQty).toFixed(2)}</u>`;
            }
          }
        }

      } else {
        let isFirstOption = this.options[this.selectedIndex].getAttribute('data-first-option');
        let NewServings = this.options[this.selectedIndex].getAttribute('data-varaint-serving');
        let NewInitialPrice = this.options[this.selectedIndex].getAttribute('data-initial-price');
        let NewServingPrice = this.options[this.selectedIndex].getAttribute('data-variant-serving-price');
        let NewTotalSave = this.options[this.selectedIndex].getAttribute('data-variant-actual-serving-price');
        let NewTotalDiscount = this.options[this.selectedIndex].getAttribute('data-price');
        let newTotalSaveValue = this.options[this.selectedIndex].getAttribute('data-variant-total-save');

        let ServingContainer = document.querySelector(`[data-serving-${productId}]`);
        let ServingSavingPriceContainer = document.querySelector(`[data-serving-saving-${productId}]`);
        let SaveContainerServing = document.querySelector(`[data-total-saving-${productId}]`);
        const priceElement = this.closest('.card-wrapper').querySelector('.card_product-price');
        // Variant doesn't exist, perform your custom logic here
        let showATC = document.querySelector(`.toggle-selection-btn[data-product-id="${productId}"]`);
        let qtyInput = document.querySelector(`.quiz_quantity[data-id="${productId}"]`);
  
        // Check if elements exist before modifying them
        if (showATC || qtyInput) {
          showATC.classList.remove('hidden');
          
          // Corrected `previousElementSibling`
          let previousSibling = showATC.previousElementSibling;
          if (previousSibling) {
            previousSibling.classList.remove('d-flex__force');
          }
  
          qtyInput.value = 1;  // Set the quantity to 1


          if(isFirstOption != null) {
            if (ServingContainer) {
              ServingContainer.innerHTML = NewServings;
            } 
            if (ServingSavingPriceContainer) {
              ServingSavingPriceContainer.innerHTML = `${isFirstOption}`;
            }
            if (SaveContainerServing) {
              SaveContainerServing.innerHTML = `$0`;
            }
            if (priceElement) {
              if(isFirstOption != null) {
                priceElement.innerHTML = `$${(wwPrice * 1).toFixed(2)}`;
              } else {
                priceElement.innerHTML = `<u class="color_black">$${(NewTotalSave * 1).toFixed(2)}</u><u class="color_green">$${(NewTotalDiscount * 1).toFixed(2)}</u>`;
              }
            }
          } else {
            if (ServingContainer) {
              ServingContainer.innerHTML = NewServings;
            } 
            if (ServingSavingPriceContainer) {
              ServingSavingPriceContainer.innerHTML = `<u class="color_black">$${NewInitialPrice}</u><u class="color_green">$${NewServingPrice}</u>`;
            }
            if (SaveContainerServing) {
              SaveContainerServing.innerHTML = `<u class="color_green">$${newTotalSaveValue}</u>`;
            }
            if (priceElement) {
              if(isFirstOption != null) {
                priceElement.innerHTML = `$${(wwPrice * 1).toFixed(2)}`;
              } else {
                priceElement.innerHTML = `<u class="color_black">$${(NewTotalSave * 1).toFixed(2)}</u><u class="color_green">$${(NewTotalDiscount * 1).toFixed(2)}</u>`;
              }
            }
          }

        }
      }
      updateCartSummary(selectedProducts);
    });
  });
  // ====== dont touch =====
});